import React from 'react';
import { Text } from '../../../components';
import classNames from 'classnames';

import './NewSummaryDetails.scss';

// const { Text } = Typography;

/**
 * SummaryDetails Component
 *
 * Renders detail rows with text/value pairs and info layouts
 */
export const NewSummaryDetails = ({ details = [] }) => {
    if (!Array.isArray(details) || details.length === 0) {
        return null;
    }

    return (
        <span className="new-summary-details">
            {details.map((detail, idx) => {
                const rowClassName = classNames('summary-detail-row');

                //if there is a value in the detail, render text/value pair
                if (detail.mainLabel !== undefined && detail.mainValue !== null) {
                    return (
                        <div key={idx} className={rowClassName}>
                            <div className="left-column">
                                <Text size="small" color="muted" bold>
                                    {detail.mainLabel}:
                                </Text>
                                <Text color="primaryBlue" extraBold>
                                    {detail.mainValue}
                                </Text>
                            </div>
                            <div className="right-column">
                                {detail.secondaryLabel && (
                                    <>
                                        <Text bold color="secondary">
                                            {detail.secondaryLabel}:
                                        </Text>
                                        <Text color="muted" extraBold>
                                            {detail.secondaryValue}
                                        </Text>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                }
                //else if there is an info in the detail, render text/subtext/info layout
                else if (detail.info) {
                    return (
                        <span key={idx} className={rowClassName}>
                            <span className="summary-detail-content">
                                <Text className="semi-bold summary-detail-text">{detail.text}</Text>
                                <Text className="summary-detail-subtext">{detail.subtext}</Text>
                            </span>
                            {/* <InfoCircleOutlined /> */}
                        </span>
                    );
                }
            })}
        </span>
    );
};

NewSummaryDetails.displayName = 'NewSummaryDetails';

export default NewSummaryDetails;
